import React from "react";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";
import LineSeparator from "commons/ui/LineSeparator";

import ExtensionsProporsionInfo from "components/subComponents/ExtensionsProporsionInfo";
import AttachmentPicker from "components/ui/AttachmentPicker";
import TitleFunctionsTopBlock from "components/ui/TitleFunctionsTopBlock";

import useCheckSectionErrors from "hooks/form/blocks/useCheckSectionErrors";
import useSectionTwo from "hooks/form/blocks/useSectionTwo";
import useTitleFunctionsTopBlock from "hooks/useTitleFunctionsTopBlock";

import { BlockEnum, DesktopOrMobile } from "types/enums";

function SectionTwoForm({ blockId }: { blockId: BlockEnum }) {
    const { setBackgroundImage, setRightImage, buttonDelete, setLeftImage, formHook } =
        useSectionTwo();

    useCheckSectionErrors({ formHook });

    const { checkErrorVisibility, setValue, form } = formHook;

    const titleFunctionsTopBlockHook = useTitleFunctionsTopBlock({
        buttonDelete: buttonDelete,
    });

    return (
        <>
            <TitleFunctionsTopBlock titleFunctionsTopBlockHook={titleFunctionsTopBlockHook} />

            {titleFunctionsTopBlockHook.closedBlock && (
                <>
                    {blockId === BlockEnum.SectionTwo && (
                        <>
                            <GridColumn>
                                <GridRow>
                                    <div className={"col-xxl-12-6 col-xl-12-12 col-xs-12-12"}>
                                        <GridRow>
                                            <GridItem>
                                                <h3>Immagine a sinistra</h3>
                                            </GridItem>
                                        </GridRow>

                                        <ExtensionsProporsionInfo
                                            desktopText={"1000x1500px (max 400KB)"}
                                            mobileText={"667x1000px  (max 250KB)"}
                                            proportion={"verticale"}
                                        />

                                        <GridRow>
                                            <GridItem className={"col-xs-12-6"}>
                                                <AttachmentPicker
                                                    buttonLabel={"Foto Desktop"}
                                                    setFile={(file) =>
                                                        setLeftImage(file, DesktopOrMobile.desktop)
                                                    }
                                                    file={form.left_img.desktop}
                                                    accept={".png,.jpg,.jpeg"}
                                                    errors={checkErrorVisibility(
                                                        "left_img.desktop"
                                                    )}
                                                />
                                            </GridItem>

                                            <GridItem className={"col-xs-12-6"}>
                                                <AttachmentPicker
                                                    buttonLabel={"Foto Mobile"}
                                                    setFile={(file) =>
                                                        setLeftImage(file, DesktopOrMobile.mobile)
                                                    }
                                                    file={form.left_img.mobile}
                                                    accept={".png,.jpg,.jpeg"}
                                                    errors={checkErrorVisibility("left_img.mobile")}
                                                />
                                            </GridItem>
                                        </GridRow>
                                    </div>

                                    <div className={"col-xxl-12-6 col-xl-12-12 col-xs-12-12"}>
                                        <GridRow>
                                            <GridItem>
                                                <h3>Immagine a destra</h3>
                                            </GridItem>
                                        </GridRow>

                                        <ExtensionsProporsionInfo
                                            desktopText={"1000x1500px (max 400KB)"}
                                            mobileText={"667x1000px  (max 250KB)"}
                                            proportion={"verticale"}
                                        />

                                        <GridRow>
                                            <GridItem className={"col-xs-12-6"}>
                                                <AttachmentPicker
                                                    buttonLabel={"Foto Desktop"}
                                                    setFile={(file) =>
                                                        setRightImage(file, DesktopOrMobile.desktop)
                                                    }
                                                    file={form.right_img.desktop}
                                                    accept={".png,.jpg,.jpeg"}
                                                    errors={checkErrorVisibility(
                                                        "right_img.desktop"
                                                    )}
                                                />
                                            </GridItem>

                                            <GridItem className={"col-xs-12-6"}>
                                                <AttachmentPicker
                                                    buttonLabel={"Foto Mobile"}
                                                    setFile={(file) =>
                                                        setRightImage(file, DesktopOrMobile.mobile)
                                                    }
                                                    file={form.right_img.mobile}
                                                    accept={".png,.jpg,.jpeg"}
                                                    errors={checkErrorVisibility(
                                                        "right_img.mobile"
                                                    )}
                                                />
                                            </GridItem>
                                        </GridRow>
                                    </div>

                                    <div className={"col-xxl-12-6 col-xl-12-12 col-xs-12-12"}>
                                        <GridRow>
                                            <GridItem>
                                                <h3>Immagine di Background</h3>
                                            </GridItem>
                                        </GridRow>

                                        <ExtensionsProporsionInfo
                                            desktopText={"1500x894px (max 200KB)"}
                                            mobileText={"1000x 596px  (max 100KB)"}
                                            proportion={"16:9"}
                                        />

                                        <GridRow>
                                            <GridItem className={"col-xs-12-6"}>
                                                <AttachmentPicker
                                                    buttonLabel={"Foto Desktop"}
                                                    setFile={(file) =>
                                                        setBackgroundImage(
                                                            file,
                                                            DesktopOrMobile.desktop
                                                        )
                                                    }
                                                    file={form.background_img.desktop}
                                                    accept={".png,.jpg,.jpeg"}
                                                    errors={checkErrorVisibility(
                                                        "background_img.desktop"
                                                    )}
                                                />
                                            </GridItem>

                                            <GridItem className={"col-xs-12-6"}>
                                                <AttachmentPicker
                                                    buttonLabel={"Foto Mobile"}
                                                    setFile={(file) =>
                                                        setBackgroundImage(
                                                            file,
                                                            DesktopOrMobile.mobile
                                                        )
                                                    }
                                                    file={form.background_img.mobile}
                                                    accept={".png,.jpg,.jpeg"}
                                                    errors={checkErrorVisibility(
                                                        "background_img.mobile"
                                                    )}
                                                />
                                            </GridItem>
                                        </GridRow>
                                    </div>
                                </GridRow>
                            </GridColumn>

                            <LineSeparator />
                        </>
                    )}

                    <GridColumn>
                        <GridRow>
                            <GridItem>
                                <h3>Video</h3>
                            </GridItem>
                        </GridRow>

                        <GridRow>
                            <GridRow>
                                <GridItem className={"col-xs-12-6"}>
                                    <InputText
                                        label={
                                            blockId === BlockEnum.SectionTwo
                                                ? "Video a sinistra"
                                                : "Url anteprima"
                                        }
                                        value={form.left_video}
                                        setValue={setValue}
                                        path={"left_video"}
                                        checkErrorVisibility={checkErrorVisibility}
                                        autoFocus
                                    />
                                </GridItem>

                                <GridItem className={"col-xs-12-6"}>
                                    <InputText
                                        label={
                                            blockId === BlockEnum.SectionTwo
                                                ? "Video a destra"
                                                : "Url video"
                                        }
                                        value={form.right_video}
                                        setValue={setValue}
                                        path={"right_video"}
                                        checkErrorVisibility={checkErrorVisibility}
                                    />
                                </GridItem>
                            </GridRow>
                        </GridRow>
                    </GridColumn>
                </>
            )}
        </>
    );
}

export default SectionTwoForm;
